import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { AppService } from 'src/app/app.service';
import { BaseInjectorService } from 'src/app/base/base-service.injector';
import { AreaOverallRatingsDetailsPage } from 'src/app/pages/house-keeping/area-overall-ratings-details/area-overall-ratings-details.page';
import { IndustrialWelfareScreenPage } from 'src/app/pages/house-keeping/industrial-welfare-screen/industrial-welfare-screen.page';
import { AreaManagementService } from 'src/app/services/area-management/area-management.service';
import { LhFirebaseService } from 'src/app/services/fire/lh-fire.service';
import { FilterActionStatusComponent } from '../filter-action-status/filter-action-status.component';
import { RatingInfoComponent } from '../rating-info/rating-info.component';
import { where } from '@angular/fire/firestore';

@Component({
    selector: 'app-rating-list',
    templateUrl: './rating-list.component.html',
    styleUrls: ['./rating-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class RatingListComponent extends BaseInjectorService implements OnInit {
from:any;
category:any;
allRatingList:any[]=[]
searchForm=new FormGroup({});
fields: FormlyFieldConfig[] = [
  {
    key: 'search_area',
    type: 'input',
    className: 'treasure-hunt-custom-add-action-parameters',
    props: {
      appearance: 'outline',
      label: this.translate.instant("HOUSE_KEEPIG.SEARCH_SITE"),
      type: 'text',
      disabled: false,
      change: (field, $event) => {
      },
    }
  }
]
model = {};
options: FormlyFormOptions = {};
areaNameList: any[]=[];
areaNameListCopy: any[]=[];
showData:boolean=true;
areaZoneList: any[]=[];
submittedDate: any;
copyAllRatingList:any[]=[];
sortingLabel: any;
userRoleType:any;
ratingTypeList:any[];
  areaZoneListCopy: any[]=[];
  showSubmittedRatingError: boolean=true;
  constructor(public areaService:AreaManagementService,
    private lhFirebaseService: LhFirebaseService,public service:AppService,
    private detectChanges: ChangeDetectorRef) { 
    super()
  }

  ngOnInit() {}
  async ionViewWillEnter(){
    console.log("userRoleType=",this.userRoleType);
    console.log("allRatingList=",this.allRatingList);
    this.allRatingList.forEach(element => {
      element['avg_rating']=Number(element.avg_rating);
      const zone_num=(element.zone_name).split(' ');
      element['zone_num']=Number(zone_num[1]);
      this.areaZoneList.push({check: true, name: element.zone_name, selected: false, order_number: element.zone_num});
      this.areaZoneListCopy.push({check: true, name: element.zone_name, selected: false, order_number: element.zone_num});
    });
    if(this.sortingLabel=="Months"){
      this.allRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
    }
    else{
      this.allRatingList.sort((a,b) => (a.zone_num) - (b.zone_num));
    }
    this.areaZoneList = Array.from(this.areaZoneList.reduce((m, t) => m.set(t.name, t), new Map()).values());
     this.areaZoneListCopy = Array.from(this.areaZoneListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
     this.areaZoneList.sort((a,b) => (a.order_number) - (b.order_number));
     this.areaZoneListCopy.sort((a,b) => (a.order_number) - (b.order_number));
    if(this.copyAllRatingList.length==0)
    this.copyAllRatingList=await this.getAreaRatings();
    console.log("copyAllRatingList=",this.copyAllRatingList);
  }
  async ionViewDidEnter(){
    console.log("category=",this.category);
    if(this.category){
      this.ratingTypeList.forEach(element => {
        this.areaNameList.push({name:element.plant_name,selected:false});
        this.areaNameListCopy.push({name:element.plant_name,selected:false});
      });
      this.areaNameList = Array.from(this.areaNameList.reduce((m, t) => m.set(t.name, t), new Map()).values());
      this.areaNameListCopy = Array.from(this.areaNameListCopy.reduce((m, t) => m.set(t.name, t), new Map()).values());
      //await this.getAreaNameList();
      console.log("docData",this.areaNameList);
      this.fields[0].formControl.valueChanges
      .subscribe(result => {
        if (result == '') { 
            this.areaNameList = this.areaNameListCopy;
        } else {
            this.areaNameList = this.areaNameListCopy.filter((val) => val.name.toLowerCase().includes(result.toLocaleLowerCase())); 
        }
        this.detectChanges.detectChanges();
      });
    }
  }
  dismiss(){
    this.modalController.dismiss();
  }
  async ratingDetails(name){
    //this.dismiss();
    let cssName:any;
    if(name==='sort'){
      cssName='open-sort-modal';
    }else{
      cssName='open-rating-info-modal';
    }
    const modal = await this.modalController.create({
      component: RatingInfoComponent,
      cssClass: cssName,
      backdropDismiss: true,
      componentProps: {
        from: name,
        ratingSubmitted:'area',
        areaZoneList:this.areaZoneList,
        areaZoneListCopy:this.areaZoneListCopy,
        submittedDate:this.submittedDate,
      }
    });
    modal.onDidDismiss().then((modelData) => {
      console.log("modelData=",modelData);
      if(modelData.data!=null){
        if(modelData.data.sortingValue!==undefined){
          this.sortingLabel=modelData.data.sortingValue;
          if(this.sortingLabel=="Months"){
            this.allRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
          }
          else{
            this.allRatingList.sort((a,b) => (a.zone_num) - (b.zone_num));
          }
        }
        else if(modelData.data.submittedDate!==undefined && modelData.data.submittedDate!==null){
          let date=this.moment(modelData.data.submittedDate.dueDateTime).toISOString();
          console.log("date=",date);
          if(modelData.data.areaZoneList.length>0){
            this.getFilterwithAreaNames(modelData.data.areaZoneList,date);
          }
        }
        else  if(modelData.data.areaZoneList.length>0){
          this.getFilterwithAreaNames(modelData.data.areaZoneList,'');
        }
        else{
          console.log("inside else=",this.copyAllRatingList);
          this.submittedDate='';
          this.areaZoneList=[];
          this.allRatingList=this.copyAllRatingList;
            if(this.allRatingList.length>0){
              this.showSubmittedRatingError=false;
            }
        }
      }
    });
    return await modal.present();
  }

  openSort(){

  }
  async openDetailsPage(data){
    console.log("data=",data);
    //this.dismiss();
    // this.areaService.setSelectedArea(data);
    // this.router.navigate(['/area-overall-ratings-details'],{replaceUrl: true});
    const modal = await this.modalController.create({
      component: AreaOverallRatingsDetailsPage,
      backdropDismiss: true,
      componentProps: {
        areaSelected:data,
      }
    });
    modal.onDidDismiss().then((modelData) => {
    });
    return await modal.present();
  }
  submit(){
    let nameList:any[]=[];
    this.areaNameList.forEach(element=>{
      if(element.selected){
        nameList.push({name:element.name});
      }
    })
    if(nameList.length==0){
      this.overlayService.presentToast(this.createToastOptions("Please select Plant"));
    }else{
      this.modalController.dismiss();
      console.log("this.ratingTypeList=",this.ratingTypeList);
      this.openPage(nameList);
      //this.areaService.setSelectedArea(this.ratingTypeList);
      //this.router.navigate(['/industrial-welfare-screen'], { queryParams: { type:this.category,userRoleType:this.userRoleType},replaceUrl: true});
    } 
  }
  async openPage(nameList){
    this.modalController.dismiss();
    const modal = await this.modalController.create({
      component: IndustrialWelfareScreenPage,
      //ssClass: cssName,
      backdropDismiss: true,
      // initialBreakpoint:0.25,
      // breakpoints:[0.25, 0.5, 0.75],
      componentProps: {
        type:this.category,
        userRoleType:this.userRoleType,
        ratingTypeList:this.ratingTypeList,
        plantNameList:nameList
        
      }
    });
    modal.onDidDismiss().then((modelData) => {
      console.log("modalData=",modelData);
    });
    return await modal.present();
  }
  async getAreaNameList(){
    let docData:any[]=[]
    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("country", '==', this.service.appData.userInfo.country)
     ,where("category",'==',this.category)
    )
    docInfo.docs?.forEach((doc: any) => {
         docData.push(doc.data().plant_name);
    });
    docData = docData.filter((el, i, a) => i === a.indexOf(el));
    console.log("docData=",docData);
    for(let i=0;i<docData.length;i++){
        console.log("i=",i);
        if(docData[i]!=undefined){
          this.areaNameList.push({name:docData[i],selected:false});
          this.areaNameListCopy.push({name:docData[i],selected:false});
        } 
    }
    if(this.areaNameList.length>0){
      this.showData=false;
    } 
  }
  selectAreaName(item,index){
    this.areaNameList[index].selected=!this.areaNameList[index].selected;
  }
  getRatingCardList(){
    if(this.sortingLabel=="Months" || this.sortingLabel=="Dates"){
      this.allRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
      this.copyAllRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
    }
    else{
      this.allRatingList.sort((a,b) => (b.zone_num) - (a.zone_num));
      this.copyAllRatingList.sort((a,b) => (b.zone_num) - (a.zone_num));
    }
  }
  async getAreaRatings(){
    let docData:any[]=[];
    let docInfo = await this.lhFirebaseService.queryCollection('area_management_ratings',where("plant", '==', this.service.appData.userInfo.plant)
     //.where("area_owner_email", '==', this.service.appData.userInfo.email)
    ,where("email", '==', this.service.appData.userInfo.email)
    )
    docInfo.docs?.forEach((doc: any) => {
      
      docData.push(doc.data());
    })
    docData.forEach(element=>{
      element['avg_rating']=Number(element.avg_rating);
      const zone_num=(element.zone_name).split(' ');
      element['zone_num']=Number(zone_num[1]);
      element['month_and_year'] = new Date(element.submitted_date).toLocaleDateString('en-GB', {
        month : 'long',
        year : 'numeric'
      }).split(' ').join('/');
    })
    return docData;
  }

  getFilterwithAreaNames(zoneList:any,submitted_date:any){
    
    if(this.sortingLabel=="Months"){
        this.allRatingList.sort((a,b) => Date.parse(b.submitted_date) - Date.parse(a.submitted_date));
    }
    else{
        this.allRatingList.sort((a,b) => (b.zone_num) - (a.zone_num));
    }
    if(zoneList.length>0){
      this.getZoneFilter(zoneList,submitted_date);
    }
  }
  getZoneFilter(zoneList,date){
    let znList:any[]=[];
    zoneList.forEach(element => {
      if(element.selected){
        znList.push(element);
      }
    });
      let filterZone:any[]=[];
      znList.forEach(data => {
        this.copyAllRatingList.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(element.zone_name==data.name){
            filterZone.push(element);
            return;
          }
        });
      });
      console.log("filterZone=",filterZone);
      if(filterZone.length>0){
        this.allRatingList=filterZone;
      }
      console.log("date inisde filter function",date);
      if(date){
        let dateFilter:any[]=[];
        this.copyAllRatingList.forEach(element => {
          element['avg_rating']=Number(element.avg_rating);
          if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
            dateFilter.push(element);
            return;
          }
        });
        this.allRatingList=dateFilter;
      }
      if(this.allRatingList.length==0){
        this.showSubmittedRatingError=true;
      }
    console.log("znList=",znList);
    if(znList.length==0){
        if(date){
          let dateFilter:any[]=[];
          this.copyAllRatingList.forEach(element => {
            element['avg_rating']=Number(element.avg_rating);
            if(new Date(date).getMonth()===new Date(element.submitted_date).getMonth()){
              dateFilter.push(element);
              return;
            }
          });
          this.allRatingList=dateFilter;
          if(this.allRatingList.length>0){
            this.showSubmittedRatingError=false;
          }
        }else{
          this.submittedDate='';
          this.areaZoneList=[];
          this.allRatingList=this.copyAllRatingList;
          if(this.allRatingList.length>0){
            this.showSubmittedRatingError=false;
          }
        }
    }
  }
 
}
